var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79175 13.4619C9.44675 13.4619 9.16675 13.1819 9.16675 12.8369V6.73108C9.16675 6.38608 9.44675 6.10608 9.79175 6.10608C10.1367 6.10608 10.4167 6.38608 10.4167 6.73108V12.8369C10.4167 13.1819 10.1367 13.4619 9.79175 13.4619Z",
    fill: "#EFF8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8472 10.4086H6.73633C6.39049 10.4086 6.11133 10.1286 6.11133 9.78357C6.11133 9.43857 6.39049 9.15857 6.73633 9.15857H12.8472C13.1922 9.15857 13.4722 9.43857 13.4722 9.78357C13.4722 10.1286 13.1922 10.4086 12.8472 10.4086Z",
    fill: "#EFF8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.88671 2.08337C3.57671 2.08337 2.08337 3.66421 2.08337 6.11254V13.4709C2.08337 15.9192 3.57671 17.5 5.88671 17.5H13.6967C16.0075 17.5 17.5 15.9192 17.5 13.4709V6.11254C17.5 3.66421 16.0075 2.08337 13.6967 2.08337H5.88671ZM13.6967 18.75H5.88671C2.86421 18.75 0.833374 16.6284 0.833374 13.4709V6.11254C0.833374 2.95504 2.86421 0.833374 5.88671 0.833374H13.6967C16.7192 0.833374 18.75 2.95504 18.75 6.11254V13.4709C18.75 16.6284 16.7192 18.75 13.6967 18.75Z",
    fill: "#EFF8FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.7fc56783.svg";
export { ForwardRef as ReactComponent };